import { Bank } from '@ap/interface-bspc-core';

export interface SessionPatch {
    status: SessionStatus;
}

export interface Session {
    id?: string;
    authentication_level?: number;
    status?: SessionStatus;
    authenticated_with_tokens?: Token[];
    authenticated_with_token_ids?: string[];
    authenticated_with_authentication_task_id?: string;
    started_from_user_agent?: string;
    started_from_ip_address?: string;
    started_from_device_fingerprint?: string;
    bank?: Bank;
    user?: User;
    natural_person?: User;
}

export enum SessionStatus {
    ACTIVE = 'active',
    TERMINATED = 'terminated',
    EXPIRED = 'expired'
}

export interface PageOfSessions {
    next_cursor: string;
    sessions: Session[];
}

export interface User {
    id: string;
    type: UserType[];
    eb_contract_id?: string;
}

export enum UserType {
    CUSTOMER = 'customer',
    EMPLOYEE = 'employee',
    PROSPECT = 'prospect',
    ANONYMOUS = 'anonymous',
    INTERMEDIARY = 'intermediary'
}

export interface Token {
    id: string;
    token_type: string;
}
